import React, { useEffect, useState, useCallback } from "react";
import Filters from "../components/Filters";
import { ErrorState } from "../components/EmptyState";
import { api, monthLabel, fmtNum } from "../lib/api";
import { TrendingUp, TrendingDown, ArrowRight, ArrowLeft } from "lucide-react";
import StatCard from "../components/StatCard";

export default function Mutasi() {
  const [filter, setFilter] = useState({ tahun: "2026", bulan: "september", rw: "", rt: "" });
  const [rekap, setRekap] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true); setError(false);
    try { setRekap(await api.rekap(filter.tahun, filter.bulan)); }
    catch { setError(true); } finally { setLoading(false); }
  }, [filter.tahun, filter.bulan]);

  useEffect(() => { load(); }, [load]);
  const s = rekap?.summary || {};

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#0e2b26] tracking-tight">Mutasi Bulanan</h1>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">
          Periode <strong>{monthLabel(filter.bulan)} {filter.tahun}</strong>
        </p>
      </div>
      <Filters value={filter} onChange={setFilter} onRefresh={load} />
      {error ? <ErrorState onRetry={load} /> : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          <StatCard label="Kelahiran" value={s.kelahiran || 0} sub="Jiwa" icon={TrendingUp} tone="accent" testId="mut-lahir" />
          <StatCard label="Kematian" value={s.kematian || 0} sub="Jiwa" icon={TrendingDown} tone="pink" testId="mut-mati" />
          <StatCard label="Pindah Keluar" value={s.pindah || 0} sub="Jiwa" icon={ArrowRight} tone="amber" testId="mut-pindah" />
          <StatCard label="Datang" value={s.datang || 0} sub="Jiwa" icon={ArrowLeft} tone="blue" testId="mut-datang" />
        </div>
      )}
      <div className="bg-white rounded-xl border border-[hsl(var(--border))] p-5">
        <h3 className="font-bold text-[#0e2b26] mb-2">Ringkasan Mutasi</h3>
        <p className="text-sm text-[hsl(var(--muted-foreground))]">
          Pada periode {monthLabel(filter.bulan)} {filter.tahun}, tercatat <strong className="text-emerald-700">{fmtNum(s.kelahiran || 0)}</strong> kelahiran,
          <strong className="text-red-600"> {fmtNum(s.kematian || 0)}</strong> kematian,
          <strong> {fmtNum(s.pindah || 0)}</strong> penduduk pindah keluar dan
          <strong> {fmtNum(s.datang || 0)}</strong> penduduk datang.
        </p>
      </div>
    </div>
  );
}
